import { render } from "./LigipaasetavusTekst.vue?vue&type=template&id=04870933&ts=true"
import script from "./LigipaasetavusTekst.vue?vue&type=script&lang=ts"
export * from "./LigipaasetavusTekst.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__